<script setup>
import { useBreakpoint } from "@/composables/useBreakpoint";
import BotaoMenuLateral from "./BotaoMenuLateral.vue";
import BotaoVoltar from "./BotaoVoltar.vue";

const props = defineProps({
    /**
     * Nome da página que vai no título do header
     */
    titulo: {
        type: String
    },
    /**
     * Subtítulo do header
     */
    subtitulo: {
        type: String
    }
});

const { isMobile } = useBreakpoint();
</script>

<template>
    <header v-if="isMobile" class="bg-white d-flex align-items-center justify-content-start gap-2 p-3">
        <BotaoVoltar :icon-style="{ color: 'var(--color-primary)' }"/>

        <div class="d-flex flex-column">
            <h5 class="m-0" style="color: var(--color-text); font-weight: 700;">
                {{ props.titulo }}
            </h5>

            <span>{{ props.subtitulo }}</span>
        </div>
    </header>
</template>

<style scoped>

</style>
